import React from 'react'
import {Row, Col} from 'antd'

export default function ViewRejectedClaim(props) {
  var data = props.parentToChild

  return (
    <>
      <div className="dash-bg-white">
        <div className="d-inline-block">
          <Row gutter={[16, 16]} style={{display: 'inline'}}>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Claim Number : </b>
                {data && data.claim_number}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Policy Number : </b>
                {data && data.policy_number}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Claim Amount : </b>
                {data && data.claim_amount}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Claim Status : </b>
                {data && data.claim_status}
              </label>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{display: 'inline'}}>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Date of Loss : </b>
                {data && data.date_of_loss}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Notification Date : </b>
                {data && data.date_of_notification}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Item Detail : </b>
                {data && data.itemdetails}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Damage Description : </b>
                {data && data.damage_description}
              </label>
            </Col>

          </Row>
          <Row gutter={[16,16]} style={{display:'inline'}}>
          <Col xs={24} md={12} lg={12}>
              <label>
                <b>Claim Notes : </b>
                {data && data.claim_notes}
              </label>
            </Col>
          </Row>
        </div>
      </div>
      
    </>
  )
}
